import { Nav, Navbar } from 'react-bootstrap';
import { routes } from 'sitemap';
import { capitalize, currencyFormat } from 'helpers/utils';
import NavbarVerticalMenu from './NavbarVerticalMenu';
import {
  UilAngleDown,
  UilArrowFromRight,
  UilLeftArrowToLeft
} from '@iconscout/react-unicons';
import { useAppContext } from 'providers/AppProvider';
import Button from 'components/base/Button';
import NavbarTopNav from '../navbar-horizontal/NavbarTopNav';
import { useBreakpoints } from 'providers/BreakpointsProvider';
import NavbarVerticalCollapseProvider from './NavbarVerticalCollapseProvider';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ConditionalRender from 'base/ConditionalRender/ConditionalRender';
import StandardTooltip from 'base/StandardTooltip/StandardTooltip';
import './NavbarVertical.scss';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/rootReducer';
import { checkAccess } from 'utils/helpers';
import { antrag } from 'utils/enums/misc';

const NavbarVerical = () => {
  const {
    config: {
      navbarPosition,
      openNavbarVertical,
      navbarVerticalAppearance,
      isNavbarVerticalCollapsed
    },
    setConfig
  } = useAppContext();

  const userPermission = useSelector(
    (state: RootState) => state.userProfile.permission
  );

  const { breakpoints } = useBreakpoints();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  // useEffect(() => {
  //   if (breakpoints.down('xxxl')) {
  //     setConfig({
  //       navbarPosition: 'vertical'
  //     });
  //   } else {
  //     setConfig({
  //       navbarPosition: 'horizontal'
  //     });
  //   }
  // }, [breakpoints.up('xxxl')]);

  // useEffect(() => {
  //   const handleKeyDown = (event: KeyboardEvent) => {
  //     const isSuper = event.metaKey; // Super/Command key
  //     const isSlash = event.key === '/';

  //     if (isSuper && isSlash) {
  //       event.preventDefault();
  //       setConfig({
  //         isNavbarVerticalCollapsed: !isNavbarVerticalCollapsed
  //       });
  //     }
  //   };

  //   window.addEventListener('keydown', handleKeyDown);

  //   // cleanup on unmount
  //   return () => {
  //     window.removeEventListener('keydown', handleKeyDown);
  //   };
  // }, [isNavbarVerticalCollapsed]);

  return (
    <NavbarVerticalCollapseProvider>
      <Navbar
        className="navbar-vertical"
        expand="lg"
        variant=""
        data-navbar-appearance={
          navbarVerticalAppearance === 'darker' ? 'darker' : ''
        }
        id="navbar-vertical"
      >
        <Navbar.Collapse
          id="navbarVerticalCollapse"
          className="scrollbar p-0 me-0"
          in={openNavbarVertical}
        >
          <div className="navbar-vertical-content">
            <Nav className="flex-column" as="ul" id="navbarVerticalNav">
              {routes.map(route => {
                const path = route.path;
                const [show, setShow] = useState(false);
                const handleClick = () => {
                  if (path) {
                    navigate(path);
                  }
                };
                const isActivePath = (): boolean => {
                  if (route.hasPages) {
                    return route.pages.some(page => {
                      return page.path === `${pathname}` || page.path === path;
                    });
                  }
                  if (!path) return false;
                  return (
                    `/${pathname.split('/').pop()}` === path ||
                    pathname.split('/').includes(path.replace('/', ''))
                  );
                };
                const Icon = route.icon;
                return (
                  <ConditionalRender
                    condition={
                      !route.permission ||
                      checkAccess([route.permission], userPermission)
                    }
                    fallBack={null}
                    key={route.label}
                  >
                    <ConditionalRender
                      condition={
                        !route.notShowInProd ||
                        process.env.REACT_APP_SUB_DOMAIN !== 'antrag'
                      }
                    >
                      <Nav.Item key={route.label}>
                        {!route.labelDisabled && (
                          <>
                            <div
                              className={`navbar-vertical-label cursor-pointer d-flex align-items-center text-center ${
                                isActivePath() ? 'active text-danger' : ''
                              } ${
                                isNavbarVerticalCollapsed
                                  ? 'p-0 justify-content-center'
                                  : ''
                              }`}
                              onClick={e => {
                                if (path) {
                                  e.preventDefault();
                                  handleClick();
                                }
                                route.pages?.length > 0 && setShow(!show);
                              }}
                            >
                              <ConditionalRender
                                condition={
                                  !isNavbarVerticalCollapsed ||
                                  breakpoints.down('sm')
                                }
                                fallBack={
                                  <StandardTooltip
                                    placement="right"
                                    text={capitalize(route.label)}
                                  >
                                    <div>
                                      <Icon size={16} />
                                    </div>
                                  </StandardTooltip>
                                }
                              >
                                <Icon className="me-2" size={16} />
                                {capitalize(route.label)}
                                {route.pages?.length > 0 && (
                                  <span className="ms-2">
                                    <UilAngleDown size={16} />
                                  </span>
                                )}
                              </ConditionalRender>
                            </div>
                            <hr className="navbar-vertical-line" />
                          </>
                        )}
                        <ConditionalRender
                          condition={show && !!route.pages?.length}
                        >
                          <NavbarVerticalMenu level={1} routes={route.pages} />
                        </ConditionalRender>
                      </Nav.Item>
                    </ConditionalRender>
                  </ConditionalRender>
                );
              })}
            </Nav>

            {navbarPosition === 'combo' && breakpoints.down('lg') && (
              <div className="move-container">
                <div className="navbar-vertical-divider">
                  <hr className="navbar-vertical-hr" />
                </div>
                <NavbarTopNav />
              </div>
            )}
          </div>
        </Navbar.Collapse>
        <div className="navbar-vertical-footer">
          <Button
            className="navbar-vertical-toggle border-0 fw-semibold w-100 white-space-nowrap d-flex align-items-center"
            onClick={() => {
              setConfig({
                isNavbarVerticalCollapsed: !isNavbarVerticalCollapsed
              });
            }}
          >
            {isNavbarVerticalCollapsed ? (
              <UilArrowFromRight size={16} className="mb-1" />
            ) : (
              <>
                <UilLeftArrowToLeft size={16} className="mb-1" />
                <span className="ms-2">Collapsed View</span>
              </>
            )}
          </Button>
        </div>
      </Navbar>
    </NavbarVerticalCollapseProvider>
  );
};

export default NavbarVerical;
